import { Message } from '@messageformat/react';

interface Props {
  isBannerLayout: boolean;
}

export const BasicInfo = ({ isBannerLayout }: Props): JSX.Element => {
  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {isBannerLayout && (
        <p>
          <Message id="basicInfo_description_for_banner_version" />
        </p>
      )}
    </>
  );
};
